import { PlanStatus } from "@src/gql/graphql";
import { useEffect } from "react";
import { useMyPlan } from "../queries/fetch-plan";
import { closePlanModal, openPlanModal } from "./plan-modal";

export function UpgradeNotice() {
	const { data: plan } = useMyPlan();

	useEffect(() => {
		switch (plan?.status) {
			case PlanStatus.TrialEnd:
			case PlanStatus.Expired:
			case PlanStatus.Paused:
				openPlanModal({ dismissible: false });
				break;
			default:
				closePlanModal();
				break;
		}
	}, [plan?.status]);

	return null;
}
